import { useSelector } from 'react-redux';
import { RootState } from 'src/redux/reducers/rootReducer';

const TS_BEFORE = 1752987600000;
const TS_AFTER = 1753030799000;

const whitelistedUser = ['bulatbulatgaringjkt'];
const disabledUser = ['qawebnewproduct'];
const instantMaintenance = false;

export const useMaintenanceConfig = () => {
  const username = useSelector(
    (state: RootState) => state.main.b2xUser.username,
  );

  const now = Date.now();

  const isWhitelisted = whitelistedUser.includes(username);
  const isDisabled = disabledUser.includes(username);
  // const isMaintenance =
  //   isDisabled ||
  //   (!isWhitelisted &&
  //     (instantMaintenance || (now >= TS_BEFORE && now <= TS_AFTER)));
  const isMaintenance = false;

  return {
    username,
    isMaintenance,
  };
};
